import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { api } from "../../../utils/axios";

let interval;
function VerifyCode({ setStage, data, setData }) {
	const [code, setCode] = useState("");
	const [codeIsValid, setCodeIsValid] = useState(true);
	const [time, setTime] = useState(120);
	const [timerIsStarted, setTimerIsStarted] = useState(true);

	const codeOnChangeHandler = (e) => {
		setCode(e.target.value);
	};

	const startTime = () => {
		interval = setInterval(() => {
			setTime((prevTime) => {
				if (prevTime > 0) {
					return prevTime - 1;
				} else return prevTime;
			});
		}, 1000);
	};

	function formOnSubmitHandler(e) {
		e.preventDefault();
		if (!codeOnChangeHandler) {
			setCodeIsValid(false);
		}
		api
			.post("/verify_reset_code", { ...data, code: code })
			.then((r) => {
				setStage(2);
			})
			.catch((err) => {
				toast.error(err?.response?.data?.error);
			});
	}

	const resendCodeHandler = (e) => {
		e.preventDefault();

		api
			.post("/forgot_password", data)
			.then((res) => {
				toast.success("کد تایید ارسال شد");
				setTimerIsStarted(true);
				startTime();
			})
			.catch((err) => {
				toast.error(err?.response?.data?.error);
			});
	};

	useEffect(() => {
		if (time === 0) {
			clearInterval(interval);
			setTime(time);
			setTimerIsStarted(false);
			setTime(120);
		}
	}, [time]);

	useEffect(() => {
		startTime();
	}, []);

	const minute = parseInt((time / 60).toString(10));
	const second = (time % 60).toFixed(0);

	return (
		<>
			<h2 className="login-title">فراموشی رمز عبور</h2>
			<form className="login-form" onSubmit={formOnSubmitHandler}>
				<div className="form-group">
					<input
						type="text"
						id="code"
						name="code"
						className="form-control"
						value={code}
						onChange={codeOnChangeHandler}
						placeholder="کد تایید ارسال شده را وارد کنید"
						maxLength={6}
					/>
					{!codeIsValid && (
						<div className={"form-helper text-danger mb-3 px-2"}>
							کد تایید را وارد کنید
						</div>
					)}
				</div>
				{time > 0 && timerIsStarted && (
					<div
						className={
							"tw-w-full tw-flex tw-flex-row tw-gap-2 tw-text-sm tw-px-3 tw-mb-[18px] tw-text-gray-500"
						}
					>
						<span className={""}>{second < 9 ? "0" + second : second}</span>:
						<span className={""}>{minute < 9 ? "0" + minute : minute}</span>
						<span>تا ارسال مجدد کد</span>
					</div>
				)}
				{!timerIsStarted && (
					<button
						onClick={resendCodeHandler}
						className={"tw-w-fit tw-text-sm tw-px-3 tw-mb-[18px]"}
					>
						<span>ارسال مجدد کد</span>
					</button>
				)}
				<div className="form-btn-group">
					<button type="submit" className="btn btn-primary">
						تایید
					</button>
				</div>
			</form>
		</>
	);
}
export default VerifyCode;
